import React from "react"
import { ArticleContentComponentContainer } from "../utils"

export const VideoYoutube = ({ content }) => {
  const video_id = content?.split("=")[1] || ""
  const video_src_url = `https://www.youtube-nocookie.com/embed/${video_id}`

  return (
    <ArticleContentComponentContainer>
      {video_id && (
        <div className="video-in-article">
          <iframe
            className="responsive-iframe"
            src={video_src_url}
            title={`youtube video with id:${video_id}`}
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            frameBorder="0"
            webkitallowfullscreen="true"
            mozallowfullscreen="true"
            allowFullScreen
          />
        </div>
      )}
    </ArticleContentComponentContainer>
  )
}
